import React from "react";
import type { TimelineEvent } from "../../../../components/RCA/types";

interface RCATimelineSectionProps {
  events: TimelineEvent[];
  onAdd: () => void;
  onUpdate: (index: number, field: keyof TimelineEvent, value: any) => void;
  onRemove: (index: number) => void;
  readOnly: boolean;
}

const RCATimelineSection: React.FC<RCATimelineSectionProps> = ({
  events,
  onAdd,
  onUpdate,
  onRemove,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">D. Timeline of Events</h3>
        {!readOnly && (
          <button
            type="button"
            onClick={onAdd}
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded hover:bg-[#0d8f8c]"
          >
            Add Event
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Sr. No</th>
              <th className="border p-2">Date</th>
              <th className="border p-2">Time</th>
              <th className="border p-2">Event</th>
              {!readOnly && <th className="border p-2">Action</th>}
            </tr>
          </thead>
          <tbody>
            {events.length === 0 ? (
              <tr>
                <td
                  colSpan={readOnly ? 4 : 5}
                  className="border p-4 text-center text-gray-500"
                >
                  No timeline events added
                </td>
              </tr>
            ) : (
              events.map((event, index) => (
                <tr key={index}>
                  <td className="border p-2">{event.srNo}</td>
                  <td className="border p-2">
                    <input
                      type="date"
                      value={event.date}
                      onChange={(e) =>
                        onUpdate(index, "date", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="time"
                      value={event.time}
                      onChange={(e) =>
                        onUpdate(index, "time", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={event.event}
                      onChange={(e) =>
                        onUpdate(index, "event", e.target.value)
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  {!readOnly && (
                    <td className="border p-2 text-center">
                      <button
                        type="button"
                        onClick={() => onRemove(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RCATimelineSection;
